import * as variables from './variables.js';

import EmailSig from './lib/emailSignature';
const emailSig = new EmailSig();

import 'window.requestanimationframe';

import * as $ from 'jquery';
declare global {
	interface Window { jQuery: JQueryStatic; }
}
window.jQuery = $;

import JSFAjaxJQueryAdapter from '@plaudit/jsf-ajax-adapters/dist/jQuery';
JSFAjaxJQueryAdapter.init();

import { Analytics } from '@plaudit/analytics';
Analytics.getInstance();

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import Forms from './component/Forms';
Forms.init();

import MainMenu from './component/MainMenu';
new MainMenu({
	menu 			: '#menu',
	menuTarget 		: '.menu__inner',
	nodeTarget_slidable : '.childWrap--L2',
	nodeTrigger 	: '.node--hasChild > a, .backToSeeAllConferences > a',
	headTarget 		: '.childWrap__heading',
	triggers 		: '#menuTrigger--open, #menuTrigger--close, #menuOverlay',
	triggerEvent 	: 'click',
	//hideSiblingMenuItems: selectorMatchesConferenceNodes,
	collapsable: {
		duration: 400
	},
	styleClass: {
		setup 			: 'hasMenuSetup',
		menuOpen 		: 'hasMenuOpen',
		nodeOpen 		: 'isOpen',
		backWrap 		: 'childWrap__back'
	}
});

import Gallery from './component/Gallery';
new Gallery();

import Gateway from './component/Gateway';
new Gateway();

document.addEventListener("DOMContentLoaded", function() {
	(document.getElementsByClassName('masthead')[0]).classList.add('ready');
}, false);
